export default "__VITE_ASSET__C8lO4SXK__"